import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

const EditButtonStyle = () => ({
  padding: 0,
  height: 'auto'
});

export const EditButton = styled(Button)(EditButtonStyle);
